import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { observer } from "mobx-react-lite";

import { userStore } from "../../stores/userStore";
import { sendCounterEvent } from "../../utils/counterService";

import "../subscription/SubscriptionInfo.css";

export const TrialBanner = observer(({ goal }: { goal?: string }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const sub = userStore.subscription;
  const visible = !!(sub && sub.allow_trial && !sub.trial_active);

  const goalFired = useRef(false);
  useEffect(() => {
    if (visible && goal && !goalFired.current) {
      goalFired.current = true;
      sendCounterEvent(goal);
    }
  }, [visible, goal]);

  if (!visible) return null;

  return (
    <div className="trial-banner">
      <div className="trial-banner__text">
        <div className="trial-banner__title">
          {t("subscription.trial.banner.title")}
        </div>
        <div className="trial-banner__desc">
          {t("subscription.trial.banner.desc")}
        </div>
      </div>
      <Button
        className="trial-banner__btn"
        size="large"
        onClick={() =>
          navigate(
            "/subscription/update/manage?trial=true&plan=pomelo&period=monthly",
          )
        }
      >
        {t("subscription.trial.banner.button")}
      </Button>
    </div>
  );
});
